module.exports = __WEBPACK_EXTERNAL_MODULE_456__;


//////////////////
// WEBPACK FOOTER
// external "gemini/dashboard/layout/views/Widget"
// module id = 456
// module chunks = 0